import './_virtual-select.dark-mode.scss';
import './_virtual-select.scss';
import React, { useState, useEffect, useRef } from 'react';
import { Dropdown, ControlLabel } from 'react-bootstrap';
import PropTypes from 'prop-types';

import SearchMenu from './components/Menu';
import SearchToggle from './components/Toggle';

import { isTouchDevice } from '../../../utils/helper';

const SearchFilter = ({
  options,
  group,
  groupKey,
  showOptionId,
  showLoader,
  menuWidth,
  toggleComponent,
  toggleBtnTitle,
  className,
  label,
  onChange,
  selectedOptions,
  selectedLimit,
  needUpdateSelected,
  disabled,
}) => {
  const inputRef = useRef(null);
  const listRef = useRef(null);

  const [values, setValues] = useState(selectedOptions);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [open, setOpen] = useState();
  const [showNotify, setShowNotify] = useState(false);

  const toggleNotify = () => {
    setTimeout(() => {
      setShowNotify(false);
    }, 2000);
  };

  const onToggleClose = () => setOpen(!open);

  const onSelectValue = (key, type) => {
    switch (type) {
    case 'group':
      const findGroupItems = options?.find((opt) => opt.id === key)?.[groupKey];
      if (findGroupItems) {
        const findGroupItemsIds = findGroupItems?.map((item) => item.id);
        if (findGroupItemsIds?.every((item) => values.includes(item))) {
          const newValue = values.filter((item) => !findGroupItemsIds.includes(item));
          if (newValue.length > selectedLimit) {
            setShowNotify(true);
          } else {
            setValues(newValue);
            onChange && onChange(newValue);
          }
        } else {
          const newValue = [...values, ...findGroupItemsIds];
          if (newValue.length > selectedLimit) {
            setShowNotify(true);
          } else {
            setValues(newValue);
            onChange && onChange(newValue);
          }
        }
      }
      break;

    default:
      if (values.includes(key)) {
        const newValue = values.filter((item) => item !== key);

        if (newValue.length > selectedLimit) {
          setShowNotify(true);
          return;
        }

        setValues(newValue);
        onChange && onChange(newValue);
      } else {
        const newValue = [...values, key];

        if (newValue.length > selectedLimit) {
          setShowNotify(true);
          return;
        }

        setValues(newValue);
        onChange && onChange(newValue);
      }
      break;
    }
  };

  const handleFocus = () => {
    if (isTouchDevice() === false) {
      return inputRef?.current?.focus();
    }
  };

  useEffect(() => {
    if (open) {
      return inputRef?.current?.focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  useEffect(() => {
    onChange && onChange(values);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]);

  useEffect(() => {
    needUpdateSelected && setValues(selectedOptions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOptions, needUpdateSelected]);

  return (
    <>
      {label && <ControlLabel>{label}</ControlLabel>}
      <Dropdown
        onToggle={onToggleClose}
        id="dropdown"
        open={open}
        disabled={disabled}
        rootCloseEvent="click"
        onFocus={() => handleFocus()}
        className={`${className || ''} dropdown-virtual`}
      >
        <SearchToggle bsRole="toggle">
          {typeof toggleComponent === 'function' ? (
            toggleComponent({ options, values })
          ) : (
            <>
              {values.length === options.length ? (
                `All ${toggleBtnTitle[0].toLowerCase() + toggleBtnTitle.slice(1)}`
              ) : (
                <>
                  {toggleBtnTitle[0] + toggleBtnTitle.slice(1)}
                  {' '}
                  <span className="options-count">{`(${values.length})`}</span>
                </>
              )}
            </>
          )}
        </SearchToggle>

        <SearchMenu
          bsRole="menu"
          inputRef={inputRef}
          listRef={listRef}
          group={group}
          groupKey={groupKey}
          showLoader={showLoader}
          setValues={setValues}
          filteredOptions={filteredOptions}
          values={values}
          options={options}
          handleFocus={handleFocus}
          onToggleClose={onToggleClose}
          onSelectValue={onSelectValue}
          setFilteredOptions={setFilteredOptions}
          showOptionId={showOptionId}
          menuWidth={menuWidth}
          selectedLimit={selectedLimit}
          showNotify={showNotify}
          toggleNotify={toggleNotify}
          setShowNotify={setShowNotify}
        />
      </Dropdown>
    </>
  );
};

SearchFilter.propTypes = {
  options: PropTypes.array,
  group: PropTypes.bool,
  groupKey: PropTypes.string,
  toggleBtnTitle: PropTypes.string,
  toggleComponent: PropTypes.func,
  className: PropTypes.string,
  label: PropTypes.string,
  showOptionId: PropTypes.bool,
  showLoader: PropTypes.bool,
  onChange: PropTypes.func,
  menuWidth: PropTypes.number,
  selectedOptions: PropTypes.array,
  selectedLimit: PropTypes.number,
  needUpdateSelected: PropTypes.bool,
  disabled: PropTypes.bool,
};

SearchFilter.defaultProps = {
  options: [],
  toggleBtnTitle: 'Options',
  showOptionId: false,
  showLoader: true,
  menuWidth: 500,
  selectedOptions: [],
  disabled: false,
};

export default SearchFilter;
